import slugify from 'slugify';
import LinkImageList from '../components/link-image-list/link-image-list';
import PageSection from '../components/page-section/page-section';
import ContentBlock from '../components/content-block/content-block';
import TextBlock from '../components/text-block/text-block';
import HeaderContentList from '../components/header-content-list/header-content-list';
import LogoChooser from '../components/logo-chooser/logo-chooser';
import TemplateChooser from '../components/template-chooser/template-chooser';
import DualHeadlineList from '../components/dual-headline-list/dual-headline-list';
import DualColumnContentBlock from '../components/dual-column-content-block/dual-column-content-block';
import BrandfolderAssets from '../components/brandfolder-assets-by-section/brandfolder-assets-by-section';
import ModalLightbox from '../components/modal-lightbox/modal-lightbox';
import HeroSearchMasthead from '../components/hero-search-masthead/hero-search-masthead';

// the keys come from Contentful content block IDs
const mapping = {
  contentBlock: ContentBlock,
  linkImageList: LinkImageList,
  pageSection: PageSection,
  textBlock: TextBlock,
  headerContentList: HeaderContentList,
  'logo-chooser': LogoChooser,
  'template-chooser': TemplateChooser,
  dualHeadlineList: DualHeadlineList,
  dualColumnContentBlock: DualColumnContentBlock,
  assetList: BrandfolderAssets,
  videoLightbox: ModalLightbox,
  heroSearch: HeroSearchMasthead,
};

export default (id, props) => {
  switch (id) {
    case 'brandEnsembleComponent': {
      const { title } = props;
      return mapping[slugify(title, { lower: true })];
    }
    default:
      return mapping[id];
  }
};
